import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-6 sm:p-8" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-[#6CC551] text-xs font-bold uppercase tracking-widest mb-1" }, "Documents", -1)
const _hoisted_4 = { class: "text-2xl font-extrabold text-[#1E2833]" }
const _hoisted_5 = {
  key: 0,
  class: "flex justify-center py-20"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-8 rounded-full border-4 border-[#6CC551] border-t-transparent animate-spin" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "bg-white rounded-2xl overflow-hidden",
  style: {"border":"1px solid #f3f4f6"}
}
const _hoisted_9 = {
  class: "px-6 py-4 flex items-center gap-3",
  style: {"border-bottom":"1px solid #f3f4f6"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-8 rounded-lg bg-[#6CC551]/10 flex items-center justify-center flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-4 h-4 text-[#6CC551]",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
    })
  ])
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold text-[#1E2833]" }, "Document Details", -1)
const _hoisted_12 = {
  class: "text-xs",
  style: {"color":"#6b7280"}
}
const _hoisted_13 = { class: "p-6 space-y-6" }
const _hoisted_14 = { class: "text-left" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", {
  class: "block mb-2 text-sm font-medium",
  style: {"color":"#374151"}
}, "Upload document", -1)
const _hoisted_16 = {
  key: 0,
  class: "mb-3 flex items-center gap-3 px-4 py-3 rounded-lg",
  style: {"border":"1px solid #e5e7eb","background":"#f9fafb"}
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-8 h-8 flex-shrink-0 text-[#6CC551]",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5",
    d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
  })
], -1)
const _hoisted_18 = { class: "min-w-0 flex-1" }
const _hoisted_19 = {
  class: "text-xs font-semibold truncate",
  style: {"color":"#111827"}
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", {
  class: "text-[10px] mt-0.5",
  style: {"color":"#6b7280"}
}, "Current document", -1)
const _hoisted_21 = ["href"]
const _hoisted_22 = {
  for: "doc-file",
  class: "flex flex-col items-center justify-center w-full h-28 rounded-lg cursor-pointer transition-colors group",
  style: {"border":"2px dashed #e5e7eb"}
}
const _hoisted_23 = { class: "flex flex-col items-center gap-1.5 pointer-events-none" }
const _hoisted_24 = {
  class: "w-7 h-7 transition-colors group-hover:text-[#6CC551]",
  style: {"color":"#d1d5db"},
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
}, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  class: "text-xs font-semibold transition-colors group-hover:text-[#6CC551]",
  style: {"color":"#6b7280"}
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", {
  class: "text-[10px]",
  style: {"color":"#6b7280"}
}, "PDF, DOC, DOCX, XLS supported", -1)
const _hoisted_29 = {
  class: "px-6 py-4 flex items-center gap-3",
  style: {"border-top":"1px solid #f3f4f6","background":"#f9fafb"}
}

import { url } from "@/functions/endpoint";
import { decryptString } from '@/functions/encryption';
import axios from "axios";
import { initTooltips } from "flowbite";
import { computed, onMounted, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import SuccessMessage from "@/components/SuccessMessage.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import Button from "@/components/Inputs/Button.vue"
import InputField from "@/components/Inputs/InputField.vue";
import SelectField from "@/components/Inputs/SelectField.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddDocument',
  setup(__props) {

onMounted(() => {
  initTooltips();
  getDocumentDetails();
});


const documentInfo = ref([]);
const getDocumentDetails = async () => {
  if (documentId.value !== undefined) {
    isEditing.value = true;
    if (isEditing.value) {
      try {
        const response = await axios.get(`${url}/department-document/${Number.parseInt(documentId.value)}`);
        const documentData = response.data;
        documentInfo.value = documentData;
        createDocumentData.title = documentData.title;
        createDocumentData.image = documentData.filename ?? documentData.image;
        // category may be a full object {id, category} or a plain id; coerce to string to match select's value type
        const catId = documentData.category?.id ?? documentData.categoryId ?? documentData.category;
        createDocumentData.category = catId == null ? '' : String(catId);
      } catch (error: any) {
        errorAlert.value = true;
        errorMessage.value = error.message;
      }
    } else {
      console.log('creating');
    }
  }
}

let isEditing = ref(false);
const route = useRoute();
const documentId = computed(() => decryptString(route.params.id.toString()));
const router = useRouter();

const currentDocumentName = computed(() => {
  const path = createDocumentData.image as string | null;
  if (!path) return '';
  return path.split('/').pop() ?? path;
});

const uploading = ref(false);
let successMessage = ref('');
let showSuccessMessage = ref(false);
let errorAlert = ref(false);
let errorMessage = ref('');

const createDocumentData = reactive({
  title: "",
  image: null,
  category: ""
});

const handleImageChange = async (event: any) => {
  const file = event.target.files[0];

  if (file) {
    const formData = new FormData();
    formData.append('file', file);

    try {
      uploading.value = true;
      showSuccessMessage.value = true;
      const response = await axios.post(`${url}/upload`, formData);
      createDocumentData.image = response.data.url;
      uploading.value = false;
      setTimeout(() => {
        showSuccessMessage.value = false;
      }, 1000)
      successMessage.value = isEditing.value ? 'New document uploaded successfully!' : 'Document uploaded successfully!';
    } catch (error: any) {
      uploading.value = false;
      errorAlert.value = true;
      setTimeout(() => {
        errorAlert.value = false;
      }, 1500)
      errorMessage.value = error?.message;
    }
  }
};


const saveDocument = async () => {
  uploading.value = true;

  try {
    const categoryId = createDocumentData.category ? Number.parseInt(createDocumentData.category) : undefined;
    const documentData: Record<string, any> = {
      title: createDocumentData.title,
      filename: createDocumentData.image,
      ...(categoryId ? { categoryId } : {})
    };

    if (createDocumentData.image && typeof createDocumentData.image !== 'string') {
      const response = await axios.post(`${url}/upload`, { image: createDocumentData.image });
      documentData.filename = response.data;
    }

    if (!isEditing.value) {
      await axios.post(`${url}/department-document`, documentData);
    } else {
      await axios.patch(`${url}/department-document/update/${Number.parseInt(documentId.value)}`, documentData);
    }

    createDocumentData.title = '';
    createDocumentData.image = null;
    createDocumentData.category = '';
    uploading.value = false;
    showSuccessMessage.value = true;
    successMessage.value = isEditing.value ? 'Document updated successfully!' : 'Document created successfully!';

    setTimeout(() => {
      showSuccessMessage.value = false;

      if (isEditing.value) {
        router.push('/admin/view-documents');
      } else {
        globalThis.location.href = "add-document";
      }
    }, 2000);

  } catch (error: any) {
    uploading.value = false;
    errorAlert.value = true;
    setTimeout(() => {
      errorAlert.value = false;
    }, 1500)
    errorMessage.value = error.message;
  }
};

const allCategories: any = ref([]);
axios.get(`${url}/document-category`)
  .then((response: any) => {
    allCategories.value = response.data;
  })
  .catch((error: string) => {
    console.error(error);
  });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(isEditing) ? "Update Document" : "Add Document"), 1)
      ]),
      (_unref(isEditing) && documentInfo.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", null, [
                _hoisted_11,
                _createElementVNode("p", _hoisted_12, "Fill in the information below to " + _toDisplayString(_unref(isEditing) ? 'update the' : 'upload a new') + " document", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(InputField, {
                label: "Title",
                id: "title",
                type: "text",
                placeholder: "Enter document title",
                isRequired: true,
                modelValue: createDocumentData.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((createDocumentData.title) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(SelectField, {
                label: "Category",
                id: "categories",
                placeholder: "Select category",
                modelValue: createDocumentData.category,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((createDocumentData.category) = $event)),
                options: allCategories.value,
                param: 'category'
              }, null, 8, ["modelValue", "options"]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                (_unref(isEditing) && createDocumentData.image)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(currentDocumentName)), 1),
                        _hoisted_20
                      ]),
                      _createElementVNode("a", {
                        href: createDocumentData.image,
                        target: "_blank",
                        class: "text-xs font-semibold text-[#6CC551] hover:underline flex-shrink-0"
                      }, "View", 8, _hoisted_21)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("label", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_24, _hoisted_26)),
                    _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(isEditing) && createDocumentData.image ? 'Click to replace document' : 'Click to upload'), 1),
                    _hoisted_28
                  ]),
                  _createElementVNode("input", {
                    id: "doc-file",
                    type: "file",
                    class: "hidden",
                    onChange: handleImageChange
                  }, null, 32)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createVNode(Button, {
                buttonText: _unref(isEditing) ? 'Update Document' : 'Publish Document',
                isDisabled: createDocumentData.title === '' || !createDocumentData.image || (!_unref(isEditing) && createDocumentData.category === '') || uploading.value,
                uploading: uploading.value,
                handleClick: saveDocument
              }, null, 8, ["buttonText", "isDisabled", "uploading"])
            ])
          ]))
    ]),
    _createVNode(SuccessMessage, {
      showSuccessMessage: _unref(showSuccessMessage),
      successMessage: _unref(successMessage)
    }, null, 8, ["showSuccessMessage", "successMessage"]),
    _createVNode(ErrorMessage, {
      errorAlert: _unref(errorAlert),
      errorMessage: _unref(errorMessage)
    }, null, 8, ["errorAlert", "errorMessage"])
  ], 64))
}
}

})